// View Transition helper (awaits async DOM updates, falls back cleanly)
if (typeof window.viewTransition !== "function") {
  window.viewTransition = function (callback) {
    const run = () => {
      const out = callback();
      return out && typeof out.then === "function" ? out : null;
    };
    if (!document.startViewTransition) {
      return run();
    }
    try {
      const tx = document.startViewTransition(() => Promise.resolve(run()));
      return tx.finished.catch(() => {});
    } catch {
      return run();
    }
  };
}

function formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
    }).format(amount)
}

function formatGlobalId(type, id) {
    return `gid://shopify/${type}/${id}`
}

function capitalize(str = '') {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// -------- Search helpers --------
function normalizeQuery(q) {
  return (typeof q === "string" ? q : "").trim();
}

function isAbortError(err) {
  // Some browsers use name=AbortError, older ones may set code=20
  return !!err && (err.name === "AbortError" || err.code === 20);
}

function getAllowedModels() {
  try {
    const el = document.getElementById("allowed-models-list");
    if (!el) return [];
    const arr = JSON.parse(el.textContent || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function filterModelsByAllowed(models, allowed) {
  if (!Array.isArray(models) || !Array.isArray(allowed) || allowed.length === 0) {
    return Array.isArray(models) ? models : [];
  }
  return models.filter(m => {
    const sku = (m?.skuNumber || "") + "";
    return allowed.some(a => sku.includes(a));
  });
}

function scrollIntoFrame(el) {
  if (el) {
    requestAnimationFrame(() => {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 200
      window.scrollTo({
        top: Math.max(0, y),
        behavior: "smooth",
      })
    })
  }
}